import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { changedValues } from "../../utils/changedValues";
import { editSegment } from "../../repositories/segmentRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const UpdateSegment = ({ location }) => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [cnaes, setCnaes] = useState(location.state.row.CNAEs);
  const [description, setDescription] = useState(location.state.row.Descricao);
  const [initialState, setInitialState] = useState({
    CNAEs: location.state.row.CNAEs,
    Descricao: location.state.row.Descricao,
  });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const resultValidation = validatesNotNull([
        { value: cnaes, key: "cnaes" },
        { value: description, key: "description" },
      ]);

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      }

      const body = changedValues({
        initial: initialState,
        current: {
          CNAEs: cnaes,
          Descricao: description,
        },
      });

      if (Object.keys(body).length < 1) return setLoading(false);

      const result = await editSegment({ id: location.state.row.Id, body });

      if (result) {
        setInitialState(Object.assign(initialState, body));
        notify("Segmento atualizado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: UpdateSegment", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">Editar segmento</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              label="Lista CNAEs*"
              autoFocus
              type="text"
              value={cnaes}
              setValue={setCnaes}
              placeholder="ex: 0111-3/02, 0111-3/03, 0111-3/99"
              error={errors.cnaes}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={255}
              label="Descrição*"
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
            />
          </Grid>

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Editar
          </button>
        </Grid>
      </Grid>
    </form>
  );
};

export default UpdateSegment;
